import React from "react";

const TwoCol = props => (
  <div
    className={props.className + " 2c"}
    style={{
      color: props.color,
      fontSize: props.fontSize,
      textAlign: props.textAlign,
      width: window.innerWidth > 899 ? "50%" : "calc(100%)",
      float: "left",
      padding: props.padding,
      display: "inline-block",
      position: "relative",
      ...props.styles
    }}
  >
    {props.children}
  </div>
);

TwoCol.defaultProps = {
  color: "#444",
  fontSize: "16px",
  lineHeight: "24px",
  textAlign: "initial",
  styles: {
    fontFamily: "Oswald, sans-serif",
    textTransform: "uppercase",
    lineHeight: "19px",
    maxWidth: window.innerWidth > 899 ? "600px" : "100%",
    border: "0px dashed #cc00cc",
    display: "inline-block",
    float: "left"
  },
  children: "Empty Two Column"
};

export default TwoCol;
